<div class="search-partner-container" [style.width]="width">
  <!-- TRIGGER / INPUT GROUP -->
  <div #trigger class="search-partner-trigger" [style.width]="width">
    <!-- Input de recherche avec boutons intégrés -->
    <div class="smart-input-wrapper smart-input"  [class.focused]="isFocused()" [style.width]="width" >
    <!-- <div class="input-wrapper"> -->
  <!-- Mode LIEN : quand un partenaire est sélectionné ET showSelectionInInput est true -->
  @if (showSelectionInInput && currentPartner && currentPartner.name && currentPartner.id ) {
    <a #searchInput class="partner-link search-input smart-input-field"  (click)="openPartnerDialog(currentPartner.id)" >
      {{ currentPartner.name }}{{ currentPartner.firstname ? ' ' + currentPartner.firstname : '' }}
    </a>
  } @else {
    <!-- Mode INPUT : recherche -->
    <input
      #searchInput
      id="nameinputsearch"
      [disabled]="!canEdit"
      type="text"
      class="search-input smart-input-field"
      [placeholder]="placeholder()"
      [value]="searchValue()"
      (input)="onSearchInput($event)"
      (focus)="onInputFocus($event)"
      (blur)="isFocused.set(false)"
      autocomplete="off"
      tabindex="1"
    />
  }
      
      <!-- Spinner de chargement -->
      <div class="spinner-container" [class.visible]="isLoading()"   >
        <svg class="spinner" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
        </svg>
      </div>

      <!-- Boutons d'action intégrés dans l'input -->
      <div class="action-buttons">
        <!-- Bouton Reset -->
        <button
          type="button"
          [disabled]="!canEdit || !currentPartner"
          class="custom-icon-button error" 
          (click)="resetPartner(searchValue())"
          (focus)="onButtonFocus()"
          (blur)="onButtonBlur()"
          title="Effacer"
          aria-label="Effacer">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>

        <!-- Bouton Recherche avancée -->
        <button 
          type="button" 
          [disabled]="!canEdit"
          class="custom-icon-button primary" 
          (click)="openPartnersDialog(searchValue())"
          (focus)="onButtonFocus()"
          (blur)="onButtonBlur()"
          title="Recherche avancée"
          aria-label="Recherche avancée">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="currentColor" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- PANEL DE RÉSULTATS (Overlay) -->
<ng-template #panel>
  <div class="search-partner-panel" role="listbox">
    @for (vm of viewModels(); track vm.raw?.id ?? $index) {
      <div 
        partnerOption
        [item]="vm.raw"
        class="partner-option"
        [class.selected]="(currentPartner && currentPartner.id )?   vm.raw.id === currentPartner.id : false"
        [class.active]="optionRef.isActive()"
        (click)="onOptionClick(vm.raw)"
        #optionRef="partnerOption">
        
        <span class="partner-name">{{ vm.label }}</span>
        @if (vm.subLabel) {
          <span class="partner-city">{{ vm.subLabel }}</span>
        }
        @if(vm.raw.id === currentPartner ) {
          <span class="check-icon">✓</span>
        }
      </div>
    } @empty {
      <!-- <div class="no-data">Aucune option disponible</div> -->
    }
  </div>
</ng-template>

<!-- PANEL D'ERREUR (Overlay) -->
<ng-template #errorPanel>
  <div class="hint-error-panel">
    <span class="hint-error-text">Aucun {{ roleLabel() }} trouvé</span>
  </div>
</ng-template>
